<template lang="pug">
#app.bg-light.app-bg.all-wrapper
  .app-loading#commonAjaxLoading(style="display: none;")
    app-loading
  router-view
</template>

<script>
import AppLoading from "@/components/AppLoading";
export default {
  components: {
    AppLoading
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    }
  },
  created() {
    if (this.$store.getters.isSSL && location.protocol === "http:") {
      location.replace(location.href.replace(/http:/, "https:"));
    }
    if (
      !this.$store.getters.isLogin &&
      window.localStorage.getItem("access_token")
    ) {
      this.authorize();
    }
  },
  methods: {
    async authorize() {
      await this.$store.dispatch("AUTHORIZE").catch(err => {
        console.log(err);
        window.localStorage.clear();
        window.sessionStorage.clear();
        this.$router.push("/login");
        return;
      });
    }
  }
};
</script>

<style src="@/stylesheets/app.scss" lang="scss"></style>
